import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { filter } from 'rxjs/operators/filter';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { concat } from 'rxjs/operators/concat';
import { publishReplay } from 'rxjs/operators/publishReplay';
import { refCount } from 'rxjs/operators/refCount';
import { combineEpics, ActionsObservable } from 'redux-observable';
import { updateProfile } from '../actions/ProfileActions';
import { updateProfile as updateProfileEpic } from './profile';
import { updateAttributeEpics } from './attributes';
import { updatePhoneNumber } from '../actions/AttributeActions';
import { updateDefaultHome } from '../actions/AttributeActions';
import { updateLanguageAndLocale } from '../actions/AttributeActions';
import { StagingActionTypes, SaveStagedChanges } from '../actions/StagingActions';
import { PROFILE_FIRST_NAME, PROFILE_LAST_NAME, LOCALE, LANGUAGE, PHONE, DEFAULT_PAGE } from '../constants/StagingDataKeys';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import { getSaveStagedChangesRequestStatus } from '../selectors/RequestStatusSelector';
import { anyRequestsFailed } from '../utils/requestUtils';
import { tracker } from '../lib/tracker';
const mapStateToInitiatingActions = ({
  stagedChanges,
  entities: {
    profile
  }
}) => {
  const initiatingActions = [];
  if (stagedChanges.has(PROFILE_FIRST_NAME) || stagedChanges.has(PROFILE_LAST_NAME)) {
    tracker.track('changedProfile', {
      action: 'changed name'
    });
    initiatingActions.push(updateProfile(profile.merge({
      firstName: stagedChanges.get(PROFILE_FIRST_NAME) || profile.get('firstName'),
      lastName: stagedChanges.get(PROFILE_LAST_NAME)
    }) || profile.get('lastName')));
  }
  if (stagedChanges.has(PHONE)) {
    tracker.track('changedProfile', {
      action: 'changed phone number'
    });
    initiatingActions.push(updatePhoneNumber(stagedChanges.get(PHONE)));
  }
  if (stagedChanges.has(DEFAULT_PAGE)) {
    initiatingActions.push(updateDefaultHome(stagedChanges.get(DEFAULT_PAGE)));
  }
  if (stagedChanges.has(LOCALE) || stagedChanges.has(LANGUAGE)) {
    initiatingActions.push(updateLanguageAndLocale({
      language: stagedChanges.get(LANGUAGE),
      locale: stagedChanges.get(LOCALE)
    }));
  }
  return initiatingActions;
};
const isRefreshNeeded = ({
  stagedChanges
}) => {
  return stagedChanges.has(LOCALE) || stagedChanges.has(LANGUAGE);
};
const metaRequestStatusTypeFilters = [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED];
export default (($action, store) => {
  return $action.ofType(StagingActionTypes.SAVE_STAGED_CHANGES).pipe(filter(() => metaRequestStatusTypeFilters.includes(getSaveStagedChangesRequestStatus(store.getState()))), mergeMap(() => {
    const refresh = isRefreshNeeded(store.getState());
    const combinedEpic = combineEpics(updateProfileEpic, updateAttributeEpics);
    const $initatingAction = ActionsObservable.from(mapStateToInitiatingActions(store.getState()));
    const $resultAction = combinedEpic($initatingAction, store, undefined).pipe(publishReplay(), refCount());
    return of(SaveStagedChanges.request()).pipe(concat($initatingAction), concat($resultAction), concat(forkJoin($resultAction).pipe(map(actions => {
      if (anyRequestsFailed(...actions.map(action => action.type))) {
        return SaveStagedChanges.failure();
      }
      // @ts-expect-error ts-migrate(2575) FIXME: No overload expects 1 arguments, but overloads do ... Remove this comment to see the full error message
      return SaveStagedChanges.success({
        refresh
      });
    }))));
  }));
});